import { Link } from "react-router-dom";
import { LGoButton } from "@/ui/branded";

interface NoBusinessYetProps {
  eyebrow: string;
  headline: string;
  body: string;
}

/** Every screen behind a podnik ends here while there is none, so each one says
 *  in its own words why it cannot work yet — and all of them offer the same one
 *  way out. */
export function NoBusinessYet({ eyebrow, headline, body }: NoBusinessYetProps) {
  return (
    <div className="max-w-xl space-y-6 py-12">
      <p className="text-sm uppercase tracking-[0.18em] text-muted-foreground">{eyebrow}</p>
      <h1 className="font-display text-5xl font-semibold leading-[0.95] tracking-tight">
        {headline}
      </h1>
      <p className="text-lg text-muted-foreground max-w-prose">{body}</p>
      <LGoButton asChild size="lg">
        <Link to="/settings">Nastavit podnik</Link>
      </LGoButton>
    </div>
  );
}
